import { Reducer } from 'redux';
import { EIcons } from '../../utils/globatTypes';
import ActionTypes, { TSideBarState } from './types';

export const initialState: TSideBarState = {
  name: EIcons.video,
};

const reducer: Reducer<TSideBarState> = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_SIDEBAR:
      return { ...state, name: action.payload };
    default:
      return state;
  }
};

export { reducer as SidebarReducer };
